export default __webpack_public_path__ + "static/media/logo.95411872.svg";